import { ICalendarEvent } from 'src/pages/Calendar/types';

export const formatApiEventsToCalendarEvents = (
  eventsData: any[]
): ICalendarEvent[] => {
  return eventsData.map((event: any) => {
    const eventDateTime: Date = new Date(event.eventDateTime);
    const endDateTime: Date = new Date(eventDateTime);
    endDateTime.setHours(endDateTime.getHours() + 1);

    return {
      id:
        event.juniperEventType === 1
          ? event.walkthroughId
          : event.serviceRequestId,
      title:
        event.name ||
        (event.juniperEventType === 1 ? 'Walkthrough' : 'Service Request'),
      start: eventDateTime,
      end: endDateTime,
      allDay: false,
      // Additional properties useful for styling and details.
      propertyName: event.propertyName,
      eventType: event.juniperEventType === 1 ? 'walkthrough' : 'service',
      // Store original event data for reference.
      originalEvent: event,
    };
  });
};
